// h5寄件接口定义
let env = true // false测试
// const baseUrl = 'https://test-api.tengzone.com' // 测试
switch (process.env.VUE_APP_ENV) {
  case 'test':
    env = false
    break
  case 'production':
    env = true
    break
}
const baseUrl = env
  ? 'https://api.tengzone.com'
  : 'https://test-api.tengzone.com'
const FEE_HOST = env
  ? 'https://wechat.tengzone.com/weixin_business_core'
  : 'https://tweixin.tengzone.com/weixin_business_core'
const NANXUN_HOST = env ? '/nanxun' : '/nanxun'
// http://1.202.152.59
const config = {
  env,
  baseURL: baseUrl,
  FEE_HOST,
  NANXUN_HOST
}
export default config
